import axios from "../plugins/axios.plugin";

class InfractionService {
  baseServicePath = "/api/infraction";

  getAllInfractions(page) {
    return axios.get(`${this.baseServicePath}/index?page=${page}&properties=1`);
  }

  filterInfractions(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}&properties=1`,
      payload
    );
  }

  storeInfraction(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }

  searchInfractions(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }

  getAnInfraction(id) {
    return axios.get(`${this.baseServicePath}/show?id=${id}&properties=1`);
  }

  getMyRewards() {
    return axios.get(`${this.baseServicePath}/me?properties=1`);
  }

  updateAnInfraction(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }
}
export const infractionService = new InfractionService();
